import type { HTMLAttributes } from 'react';

import { fromNow } from '../../helpers/date';

type Props = {
  time: string;
  timeAgoBasis: 'one-day' | 'one-month';
} & HTMLAttributes<HTMLSpanElement>;

const RelativeTime = (props: Props) => {
  const { time, timeAgoBasis, ...rest } = props;

  return (
    <span className="fa" suppressHydrationWarning {...rest}>
      {fromNow(time, timeAgoBasis, 'dd MMMM yy')}
    </span>
  );
};

export default RelativeTime;
